import { useContext } from 'react';
import { RouterContext } from 'next/dist/shared/lib/router-context.shared-runtime';
import { usePathname } from 'next/navigation';
import { useIceChat } from '@hooks/useIceChat';
import { useTranslation } from 'next-i18next';
import cn from 'classnames';

import styles from './IceChatButton.module.scss';

const IceChatButton = () => {
  // Dual-router compatibility: support both Pages Router and App Router
  const pagesRouter = useContext(RouterContext);
  const appRouterPathname = usePathname();
  const pathname = pagesRouter?.asPath || appRouterPathname || '/';

  const openChat = useIceChat();
  const { t } = useTranslation();

  return (
    <div
      className={cn(styles.container, {
        [styles.bumpUp]: pathname.includes('product/'),
      })}
    >
      <button
        type="button"
        className={styles.button}
        onClick={openChat}
        aria-label={t('contact.livechat.button')}
      >
        <div className={styles.icon}>
          <svg
            className={styles.default}
            viewBox="0 0 32 32"
            aria-hidden="true"
            focusable="false"
          >
            <path
              className={styles.outside}
              d="M12.63 26.46h-3.8a6.61 6.61 0 0 1-6.65-6.07 89.05 89.05 0 0 1 0-11.2 6.5 6.5 0 0 1 6.05-5.94 121.62 121.62 0 0 1 15.51 0 6.51 6.51 0 0 1 6.06 5.94 77.53 77.53 0 0 1 0 11.2 6.61 6.61 0 0 1-6.66 6.07h-3.66L12.63 31v-4.54"
            />
            <path
              className={styles.inside}
              d="M19.57 21.68h3.67a2.08 2.08 0 0 0 2.11-1.81 89.86 89.86 0 0 0 0-10.38 1.9 1.9 0 0 0-1.84-1.74 113.15 113.15 0 0 0-15 0 1.9 1.9 0 0 0-1.8 1.74 74.92 74.92 0 0 0-.06 10.38 2 2 0 0 0 2.1 1.81h3.81v4.82Z"
            />
          </svg>
          <div className={styles.iconHover}>
            <svg
              viewBox="0 0 60 40"
              width="18px"
              aria-hidden="true"
              focusable="false"
            >
              <circle r="6" cy="20" cx="9" className={styles.iconHover1} />
              <circle r="6" cy="20" cx="30" className={styles.iconHover2} />
              <circle r="6" cy="20" cx="51" className={styles.iconHover3} />
            </svg>
          </div>
        </div>
      </button>
    </div>
  );
};

export default IceChatButton;
